/* eslint-disable react/forbid-prop-types */
import React from 'react';
import * as XLSX from 'xlsx';
import { Row, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import ResizableDataTable from '../../../Tables/ResizableTable/components/ResizableReactTable';
import { setCurrencyFormat } from '../../../../utils/helpers';

const RevenueCustomerTable = ({ data, tableHeaderData, fileName }) => {
    const excelData = data.map((item) => {
        const keys = Object.keys(item);
        const obj = {};

        keys.forEach((key) => {
            if (key !== 'customer') {
                obj[key] = setCurrencyFormat(Number(item[key] || 0).toFixed(item[key] ? 2 : 0), true)
            } else {
                obj[key] = item[key]
            }
        })

        return obj
    })

    const handleDownload = () => {
        if (!data.length) return;

        // Create a new workbook
        const wb = XLSX.utils.book_new();

        // Create headers array from tableHeaderData
        const headers = tableHeaderData?.map(col => col.Header) || [];

        // Create data array with only the fields specified in tableHeaderData
        const worksheetData = excelData?.map(row => {
            const filteredRow = {};
            tableHeaderData?.forEach(col => {
                filteredRow[col.Header] = row[col.accessor];
            });
            return filteredRow;
        }) || [];

        // Convert data to worksheet format with proper headers
        const ws = XLSX.utils.json_to_sheet(worksheetData, { header: headers });

        // Add worksheet to workbook
        XLSX.utils.book_append_sheet(wb, ws, 'report');

        // Write the file
        XLSX.writeFile(wb, `${fileName}.xlsx`);
    };


    return (
        <Row style={{ position: 'relative' }} className="profit-table">
            <div className="ExcelTable" id='dvTable'>
                <Button
                    disabled={!data.length}
                    className="download-monthly-sub-order-report btn-primary btn btn-sm"
                    onClick={handleDownload}
                >
                    Download
                </Button>
            </div>
            <ResizableDataTable reactTableData={{ tableHeaderData }} data={data} />
        </Row>
    )

}



RevenueCustomerTable.propTypes = {
    data: PropTypes.array.isRequired,
    tableHeaderData: PropTypes.array.isRequired,
    fileName: PropTypes.string,
};

RevenueCustomerTable.defaultProps = {
    fileName: "Revenue From Customer Report",
}


export default RevenueCustomerTable;